import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { hiringCompanySettingsTabs } from "./account.const";

const Account: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeTab = pathname;

  return (
    <div className="flex flex-col md:flex-row mt-6 gap-6 h-full">
      {/* Sidebar */}
      <div className="w-full md:w-64 shrink-0 border-r pr-1">
        <div className="rounded-md text-xs space-y-2">
          {hiringCompanySettingsTabs?.map((x) => (
            <div
              onClick={() => navigate(x.path)}
              className={`px-4 py-3 cursor-pointer rounded-md ${
                activeTab === x.path
                  ? "bg-gray-100 font-medium"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {x.name}
            </div>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Account;
